import { shortGamePath } from './routes';
import { boxSubdomain } from '@lub0v/santa-utils';
import { configuredBrowserBoxDomains } from './boxDomainNavigation';

/**
 * The path part of a URL the backend built.
 *
 * The API composes links from its own configured frontend origin, which in
 * production is the same host serving both v1 and v2 but in development is
 * santa-frontend on :8080. Keeping only the path means a claim made in v2
 * lands on the v2 card instead of silently handing the visitor to v1.
 */
export function apiUrlPath(url: string): string {
  try {
    const parsed = new URL(url, window.location.origin);
    const key = window.__ssBoxKey;
    const path = key ? shortGamePath(parsed.pathname, key) : parsed.pathname;
    return `${path}${parsed.search}${parsed.hash}`;
  } catch {
    // Not a URL at all: hand it back as given and let the caller decide.
    return url;
  }
}

/**
 * A backend-built URL as a link to hand to someone else: same path, but on the
 * host this page is being read from. On the live site the two are already the
 * same; in development it is the difference between a link that opens the app
 * the sender is looking at and one that opens the other frontend.
 */
export function sameOriginUrl(url: string): string {
  if (typeof window === 'undefined') {
    return url;
  }
  try {
    const parsed = new URL(url);
    const label = boxSubdomain(parsed.hostname, configuredBrowserBoxDomains());
    if (label) {
      const key = window.__ssBoxKey;
      if (key && parsed.hostname === window.location.hostname) {
        parsed.pathname = shortGamePath(parsed.pathname, key);
      }
      return parsed.href;
    }
  } catch {
    /* Relative API links use the current origin. */
  }
  const path = apiUrlPath(url);
  return path.startsWith('/') ? `${window.location.origin}${path}` : path;
}
